import React from 'react';
import '../styles/TickerSeparator.css';

export const TickerSeparator = () => {
    return <div className="separator">&nbsp;</div>;
}